export enum ItemStatus {
  Incomplete = 'incomplete',
  Complete = 'complete',
  Error = 'error',
}

export enum ReviewType {
  Issue = 'issue',
  CloneIssue = 'cloneIssue',
  Performance = 'performance',
  Optimization = 'Optimization',
}

export enum JourneyReviewTabs {
  Issues = 'Issues',
  Performance = 'Performance',
}
